import WhtEditModal from './WhtEditModal'

export default WhtEditModal